import React from 'react';
import { Box, Typography } from '@mui/material';
import data from './data.json';
// import Copyright from 'components/CopyRight';

const TermsOfUse = () => {
  return (
    <Box sx={{my: 2, mb: '51px'}}>
      <Typography variant="h4" component="h1" color="secondary" align="center">
        Terms of Use
      </Typography>
      <Box sx={{mt: 2}}>
        <Typography variant="h6" color="secondary">
        PLEASE READ THE FOLLOWING TERMS AND CONDITIONS OF USE CAREFULLY BEFORE USING THIS WEBSITE AND APPLICATIONS.
        </Typography>
        <Typography variant="body2">
        All users of this site agree that access to and use of this site are subject to the following terms and conditions and other applicable laws. If you do not agree to these terms and conditions, please do not use this site and app.
        </Typography>
      </Box>
      {data.map(({heading, description}, i) => (
        <Box sx={{mt: 2.2}} key={i}>
          <Typography variant="subtitle2" component="h2" color="secondary"
            dangerouslySetInnerHTML={{
              __html: heading
            }}
          />
          {description.map((text, j) => (
            <Typography variant="body2"  key={j}
              sx={{mb: 1.4}}
              dangerouslySetInnerHTML={{
                __html: text
              }}
            />
          ))}
        </Box>
      ))}
      {/* <Copyright /> */}
    </Box>
  );
}
 
export default TermsOfUse;
